import { render, staticRenderFns } from "./SingleAdoptedFirm.vue?vue&type=template&id=e48f229c&scoped=true&"
import script from "./SingleAdoptedFirm.vue?vue&type=script&lang=js&"
export * from "./SingleAdoptedFirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48f229c",
  null
  
)

export default component.exports